import { BlockStack, InlineStack, Modal, TextField, Button, Form, Banner, FormLayout } from '@shopify/polaris';
import __ from 'languages/index';
import { useCallback, useEffect, useState } from 'react';
import helpers from 'helpers/index';
import { useUserLogin } from 'queries/user.query';
import { lengthLessThan, lengthMoreThan, notEmptyString, useField, useForm } from '@shopify/react-form';
import { ViewIcon, HideIcon, PersonLockFilledIcon } from '@shopify/polaris-icons';

/**
 * Xác thực hai bước, quan trọng!
 */
export default function UserQuickloginModal({ show = false }: { show: boolean }) {
  const { mutateAsync: loginFn, isPending: loading } = useUserLogin();
  const [showModal, setShowModal] = useState(false);
  const [viewPasswordMode, setViewPasswordMode] = useState(false);
  const __passport = (window as any).__passport || '';

  useEffect(() => {
    if (
      window.location.pathname !== '/login' &&
      window.location.pathname !== '/register' &&
      window.location.pathname !== '/forgot-password' &&
      window.location.pathname !== '/'
    ) {
      setShowModal(show);
    }
  }, [show]);

  const hideModal = useCallback(async () => {
    setShowModal(false);
  }, []);

  /**
   * Khai báo field cho form!
   */
  const useFields = {
    user_input: useField<string>({
      value: '',
      validates: [
        notEmptyString('Trường này không được để trống.'),
        lengthLessThan(50, 'Bạn điền quá dài!'),
        (inputValue) => {
          if (!helpers.isPhoneNumber(inputValue))
            if (!helpers.isEmail(inputValue)) {
              return 'Định dạng Email không hợp lệ! Vui lòng kiểm tra lại email của bạn!';
            }
          if (helpers.isUTF8(inputValue)) {
            return 'Trường này không nên có mã Unicode, bạn vui lòng kiểm tra lại!';
          }
        },
      ],
    }),
    password: useField<string>({
      value: '',
      validates: [
        notEmptyString('Trường này không được để trống.'),
        lengthMoreThan(6, 'Mật khẩu quá ngắn!'),
        (inputValue) => {
          if (helpers.isUTF8(inputValue)) {
            return 'Không nên dùng mã Unicode trong mật khẩu của bạn!';
          }
        },
      ],
    }),
  };

  const {
    fields,
    submit,
    reset: resetForm,
    makeClean,
  } = useForm({
    fields: useFields,
    async onSubmit(form) {
      await loginFn({
        user_input: form.user_input,
        password: form.password,
        device_type: 'website',
        device_signature: 'a_ignore' /** For notification, but website doesn't need it ... */,
        device_uuid: __passport,
      })
        .then(() => {
          // let { access_token, refresh_token, expires_at } = data;
          // helpers.cookie_set('AT', access_token);
          // helpers.cookie_set('RT', refresh_token);
          // helpers.cookie_set('EA', expires_at);
          hideModal();
        })
        .catch((e) => {
          setInternalErrorShow(e?.message);
        });
      return { status: 'success' };
    },
  });

  useEffect(() => {
    resetForm();
    makeClean();
  }, []);

  const [internalErrorShow, setInternalErrorShow] = useState('');
  const clearInternalError = useCallback(() => {
    setInternalErrorShow('');
  }, []);
  return (
    <>
      <Modal activator={null} open={showModal} onClose={hideModal} title={`Yêu cầu đăng nhập`}>
        <Modal.Section>
          {internalErrorShow && (
            <>
              <Banner tone="critical" onDismiss={clearInternalError}>
                {internalErrorShow}
              </Banner>
              <br />
            </>
          )}

          <>
            <Form onSubmit={submit}>
              <BlockStack gap="400">
                <FormLayout>
                  <TextField
                    type="text"
                    disabled={loading}
                    placeholder=""
                    label={__('login_by_your_account')}
                    {...fields.user_input}
                    requiredIndicator
                    autoComplete="off"
                  />
                  <TextField
                    disabled={loading}
                    label={__('login_by_your_password')}
                    placeholder="******"
                    type={viewPasswordMode ? 'text' : 'password'}
                    requiredIndicator
                    autoComplete="off"
                    suffix={
                      <InlineStack blockAlign="center">
                        <Button
                          variant="plain"
                          onClick={() => setViewPasswordMode(!viewPasswordMode)}
                          icon={viewPasswordMode ? ViewIcon : HideIcon}
                        ></Button>
                      </InlineStack>
                    }
                    {...fields.password}
                  />
                </FormLayout>
                <Button
                  icon={PersonLockFilledIcon}
                  submit
                  variant="primary"
                  fullWidth
                  disabled={loading}
                  onClick={submit}
                  key={'button_login_normal'}
                  size="large"
                >
                  {__('login_button_context')}
                </Button>
              </BlockStack>
            </Form>
          </>
        </Modal.Section>
      </Modal>
    </>
  );
}
